import { FC } from 'react';
import {
	CalendarResponseDto,
	DocumentType,
} from '@/features/calendar/types/calendar-dto';
import { cn } from '@/lib/utils';
import { BookingCalendarSingle } from '@/components/ui/bookingCalendarSingle';

type Props = {
	selectedDate: Date;
	setSelectedDate: (date: Date) => void;
	isLoading: boolean;
	minWidth?: string;
	showReservationDetails?: (
		id: string,
		type: DocumentType,
		apartmentId?: string,
		checkInDate?: Date,
		checkOutDate?: Date,
	) => void;
} & CalendarResponseDto;

const CalendarMonthlySingle: FC<Props> = ({
	apartments,
	selectedDate,
	setSelectedDate,
	isLoading,
	minWidth = '360px',
	showReservationDetails,
}) => {
	return (
		<div
			className={cn(`grid gap-4`)}
			style={{
				gridTemplateColumns: `repeat(auto-fill, minmax(${minWidth}, 1fr))`,
			}}>
			<div className='p-4 flex items-center justify-center border border-popover-100 rounded-2.5xl bg-popover-10'>
				<BookingCalendarSingle
					apartments={isLoading ? [] : apartments}
					selectedDate={selectedDate}
					setSelectedDate={setSelectedDate}
					showReservationDetails={showReservationDetails}
				/>
			</div>
		</div>
	);
};

export default CalendarMonthlySingle;
